module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Quick Lead"},"fr":{"title":"Référence rapide"}}')
  delete Component.options._Ctor
}
